module.exports = __webpack_public_path__ + "static/img/showcase_gap.70ee358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_gap.png
// module id = 753
// module chunks = 1